module.exports = __webpack_public_path__ + "static/media/TRIAL 3 if-both-correct.085ec215.mp3";